import { Flex, Input, Pagination, Select } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useRef, useState } from 'react'
import { useRecoilState } from 'recoil'
import inquiryApi from '../../api/inquiry.api'
import pushApi from '../../api/push.api'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import styles from '../../styles/inquiry.module.scss'

const { TextArea } = Input

const InquiryListPage = () => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  const [categoryList, setCategoryList] = useState([
    { value: 0, label: '전체' },
  ])
  const [inquiryEndType, setInquiryEndType] = useState(false)
  const [inquiryType, setInquiryType] = useState(0) //전체 0, 이용방법1, 기능오류2, 기타문의3, 상품문의 38
  const [dateType, setDateType] = useState('desc')
  const [offset, setOffset] = useState(0)
  const [totalSize, setTotalSize] = useState(1)
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [inquiryAnswer, setInquiryAnswer] = useState('')
  const [inquiryAnswerValidation, setInquiryAnswerValidation] = useState(false)

  const [csInquiryList, setCsInquiryList] = useState([])
  const [currentInquiry, setCurrentInquiry] = useState({})

  const [imageList, setImageList] = useState([])
  const [modalImage, setModalImage] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const scrollContainerRef = useRef(null)
  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [currentInquiry])

  const pageSize = 10
  const dateItems = [
    { value: 'desc', label: '최신순' },
    { value: 'asc', label: '오래된순' },
  ]

  useEffect(() => {
    readInquiryCategory()
    setIsModalOpen(false)
  }, [])

  useEffect(() => {
    readInquiryList()
  }, [inquiryEndType, inquiryType, dateType, offset])

  /**
   * 문의 카테고리 목록 조회
   */
  const readInquiryCategory = async () => {
    try {
      const param = {
        isTotal: true,
        isAdmin: true,
      }
      const res = await inquiryApi.readCategoryList(param)
      // console.log('res', res.data.result)
      if (res.data.code === 200) {
        // 제외할 카테고리 ID 목록
        // 9: 제휴, 10: 광고, 11:투자 (*셋 모두 고객센터에서 없어진 목록)
        const excludedCategoryIds = [9, 10, 11]

        const filteredCategories = res.data.result?.categoryList.filter(
          (category) => !excludedCategoryIds.includes(category.id),
        )

        setCategoryList(
          filteredCategories.map((categoryInfo) => ({
            value: categoryInfo.id,
            label: categoryInfo.category_name,
            category_type: categoryInfo.category_type,
          })),
        )
      } else {
        throw res.data.code
      }
    } catch (e) {
      console.log('InquiryListPage :: readInquiryCategory error = ', e)
      setCategoryList([{ value: 0, label: '전체' }])
    }
  }

  /**
   * 문의 목록 조회
   */
  const readInquiryList = async () => {
    setIsLoading(true)
    try {
      const param = {
        offset: offset,
        pageSize: pageSize,
        answerStatus: inquiryEndType,
        inquiryType: inquiryType,
        orderType: 'created_at',
        orderBy: dateType,
      }
      const res = await inquiryApi.readInquiryList(param)
      if (res.data.code === 200) {
        setCsInquiryList(res.data.result?.inquiryList)
        if (res.data.result.totalCnt !== 0) {
          setTotalSize(res.data.result.totalCnt)
        }
      } else {
        throw res.data.code
      }
    } catch (e) {
      console.log('InquiryListPage :: readInquiryList error = ', e)
      alert(
        '문의 목록을 조회하는데 실패하였습니다. 다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.',
      )
      setCsInquiryList([])
      setTotalSize(1)
    } finally {
      setIsLoading(false)
    }
  }

  /**
   * 문의 답변 등록/수정하기
   */
  const submitInquiryAnswer = async () => {
    setIsLoading(true)
    try {
      const param = {
        id: currentInquiry.id,
        answer_content: inquiryAnswer,
        created_by: user.id,
      }
      let res
      if (inquiryEndType) {
        res = await inquiryApi.editInquiryAnswer(param)
      } else {
        res = await inquiryApi.createInquiryAnswer(param)
      }
      if (res && res.data.code === 200) {
        let successMsg = '새로운 답변이 등록되었습니다'
        if (inquiryEndType) {
          successMsg = '해당 문의사항에 대한 답변이 수정되었습니다'
        } else {
          // 앱 푸시 전송하기
          const findIdx = categoryList?.findIndex(
            (category) =>
              category.category_type === 'inquiry' &&
              category.value === currentInquiry.category_id,
          )
          if (findIdx > 0) {
            const pushParam = {
              type: 'inquiry',
              pushId: currentInquiry.id,
              userId: currentInquiry.created_by,
            }
            const pushRes = await pushApi.sendAppPush(pushParam)
          }
        }
        alert(successMsg)
        initialInquiryInfo()
      } else if (res && res.data.code === 400) {
        let errorMsg = '이미 삭제된 문의입니다.'
        if (inquiryEndType) {
          errorMsg = '답변이 등록되지 않은 문의이거나 이미 삭제된 문의입니다.'
        }
        alert(errorMsg)
        initialInquiryInfo()
      } else if (res && res.data.code === 999) {
        alert(res.data.msg)
      } else {
        throw res?.data.code
      }
    } catch (e) {
      console.log('InquiryListPage :: submitInquiryAnswer error = ', e)
      alert('오류가 발생했습니다. 관리자에게 문의하세요')
    } finally {
      setIsLoading(false)
    }
  }

  /**
   * 대기중 <-> 답변완료
   * 대기중 : false, 답변완료 : true
   */
  const handleStatusChange = (result) => {
    setInquiryEndType(result)
    handleChangePage(1)
    setInquiryAnswer('')
    setInquiryAnswerValidation(false)
  }

  /**
   * 문의 유형 및 정렬 순서 선택 이벤트 핸들러
   * @param value
   * @param type inquiry/date
   */
  const handleSelectChange = (value, type) => {
    if (type === 'inquiry') {
      setInquiryType(value)
    } else {
      setDateType(value)
    }
    handleChangePage(1)
  }

  /**
   * 문의 답변 text 입력 이벤트 핸들러
   */
  const handleTextChange = (e) => {
    if (e.target.value?.trim() !== '') {
      setInquiryAnswer(e.target.value)
      setInquiryAnswerValidation(true)
    } else {
      setInquiryAnswer('')
      setInquiryAnswerValidation(false)
    }
  }

  /**
   * handleChangePage
   */
  const handleChangePage = (pageNumber) => {
    const offset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(offset)
  }

  /**
   * 문의 관련 데이터 초기화
   */
  const initialInquiryInfo = () => {
    readInquiryList()
    setCurrentInquiry({})
    setInquiryType(0)
    setDateType('desc')
    handleStatusChange(inquiryEndType)
  }

  // 문의 이미지 조회
  const getImageList = async () => {
    try {
      const param = {
        category: 'INQUIRY',
        uniqueId: currentInquiry?.id,
      }
      const res = await inquiryApi.getReviewImage(param)
      setImageList(res)
    } catch (e) {
      console.log('getReviewImage:: ', e)
      setImageList([])
      return
    }
  }
  useEffect(() => {
    if (currentInquiry && currentInquiry.id) {
      getImageList()
    }
  }, [currentInquiry])

  const handleImageClick = (url) => {
    setIsModalOpen(true)
    setModalImage(url)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setModalImage(null)
  }

  return (
    <>
      <ContentHeader title={'회원문의 관리'} isBorder />
      <Flex className={`${styles['inquiry-content-wrap']}`}>
        <div className={`${styles['cs-inquiry-menu-wrap']}`}>
          {/* 대기중 답변 완료 */}
          <Flex
            justify={'space-around'}
            align={'center'}
            className={`${styles['cs-inquiry-menu-status-wrap']}`}
          >
            <div
              onClick={() => handleStatusChange(false)}
              className={`${styles['inquiry-main-menu-status-wait']} ${inquiryEndType ? '' : styles.active}`}
            >
              <div className={`${styles['inquiry-main-menu-status-wait-img']}`}>
                <img
                  src={`${process.env.REACT_APP_HOST}/assets/${
                    inquiryEndType ? 'wait' : 'wait_active'
                  }.png`}
                />
              </div>
              대기중
            </div>
            <div className={`${styles['inquiry-main-menu-status-divider']}`}>
              |
            </div>
            <div
              onClick={() => handleStatusChange(true)}
              className={`${styles['inquiry-main-menu-status-end']} ${inquiryEndType ? styles.active : ''}`}
            >
              <div className={`${styles['inquiry-main-menu-status-end-img']}`}>
                <img
                  src={`${process.env.REACT_APP_HOST}/assets/${
                    inquiryEndType ? 'answer_active' : 'answer'
                  }.png`}
                />
              </div>
              답변완료
            </div>
          </Flex>

          <Flex
            justify={'space-between'}
            align={'center'}
            className={`${styles['inquiry-main-menu-title-wrap']}`}
          >
            <Select
              className={`${styles['inquiry-main-menu-sort']}`}
              value={inquiryType}
              options={categoryList}
              onChange={(value) => handleSelectChange(value, 'inquiry')}
            />
            <Select
              className={`${styles['inquiry-main-menu-order']}`}
              value={dateType}
              options={dateItems}
              onChange={(value) => handleSelectChange(value, 'date')}
            />
          </Flex>
          <div className={`${styles['inquiry-main-menu-contents-wrap']}`}>
            {csInquiryList?.length > 0 && (
              <>
                {csInquiryList.map((item) => (
                  <Flex
                    vertical
                    justify={'center'}
                    key={'waitInquiry_' + item.id}
                    onClick={() => setCurrentInquiry(item)}
                    className={`${styles['inquiry-main-menu-content-wrap']} ${
                      Object.prototype.hasOwnProperty.call(
                        currentInquiry,
                        'id',
                      ) && currentInquiry.id === item.id
                        ? styles.active
                        : ''
                    }`}
                  >
                    <div>
                      <div className={`${styles['inquiry-main-menu-info']}`}>
                        [{item.category_name}] {item.name}
                      </div>
                      <div className={`${styles['inquiry-main-menu-content']}`}>
                        {item.content}
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div className={`${styles['inquiry-main-menu-date']}`}>
                        ID: {item.created_by}
                      </div>
                      <div className={`${styles['inquiry-main-menu-date']}`}>
                        {dayjs(item.created_at).format('YYYY/MM/DD HH:mm')}
                      </div>
                    </div>
                  </Flex>
                ))}
              </>
            )}
          </div>
          <Flex
            justify={'center'}
            align={'center'}
            className={`${styles['cs-inquiry-main-menu-pagination-wrap']}`}
          >
            <Pagination
              size="small"
              total={totalSize}
              simple
              pageSize={pageSize}
              onChange={handleChangePage}
              current={currentPageNumber}
              style={{ display: 'flex' }}
            />
          </Flex>
        </div>
        <Flex vertical className={`${styles['cs-inquiry-content-wrap']}`}>
          <Flex
            justify={'space-between'}
            align={'center'}
            className={`${styles['inquiry-main-content-header-wrap']}`}
          >
            <div className={`${styles['inquiry-main-content-info-wrap']}`}>
              {currentInquiry && Object.keys(currentInquiry)?.length !== 0 && (
                <>
                  <div className={`${styles['cs-inquiry-content-info-title']}`}>
                    [{currentInquiry.category_name}] {currentInquiry.name}{' '}
                    문의사항
                  </div>
                  {imageList?.length > 0 && (
                    <span>(*사진을 더 크게 보고 싶으실 경우 클릭하세요.)</span>
                  )}
                  {currentInquiry.company_name && (
                    <div
                      className={`${styles['cs-inquiry-content-info-company']}`}
                    >
                      {currentInquiry?.company_name}{' '}
                      {currentInquiry?.company_part} {currentInquiry?.name} /{' '}
                      {currentInquiry?.phone}
                    </div>
                  )}
                </>
              )}
            </div>
          </Flex>
          <Flex
            vertical
            justify={'space-between'}
            className={`${styles['inquiry-main-content-wrap']}`}
          >
            <div
              className={`${styles['inquiry-main-content-chat-wrap']}`}
              ref={scrollContainerRef}
            >
              {currentInquiry && Object.keys(currentInquiry)?.length !== 0 && (
                <Flex
                  className={`${styles['user-inquiry-text-wrap']}`}
                  vertical
                >
                  {imageList?.length > 0 && (
                    <Flex wrap="wrap" gap={10} style={{ marginBottom: 12 }}>
                      {imageList?.map((item) => (
                        <div
                          key={item.id}
                          onClick={() => handleImageClick(item.url)}
                        >
                          <img
                            src={item.url}
                            alt={`inquiryImage-${item.id}`}
                            style={{
                              width: 200,
                              height: 200,
                              objectFit: 'contain',
                            }}
                          />
                        </div>
                      ))}
                    </Flex>
                  )}
                  <div>
                    <pre className={`${styles['user-inquiry-text']}`}>
                      {currentInquiry.content}
                    </pre>
                    <div className={`${styles['inquiry-text-date']}`}>
                      {dayjs(currentInquiry.created_at).format(`YY-MM-DD`)}
                    </div>
                  </div>
                </Flex>
              )}
              {currentInquiry && currentInquiry?.is_answer && (
                <Flex
                  justify={'flex-end'}
                  className={`${styles['admin-inquiry-text-wrap']}`}
                >
                  <div className={`${styles['inquiry-text-date']}`}>
                    {dayjs(currentInquiry.answer_date).format(`YY-MM-DD`)}
                  </div>
                  <div className={`${styles['admin-inquiry-text']}`}>
                    {currentInquiry.answer_content}
                  </div>
                </Flex>
              )}
            </div>
            <Flex
              vertical
              className={`${styles['inquiry-main-content-answer-wrap']}`}
            >
              <Flex
                className={`${styles['inquiry-main-content-answer-text-wrap']}`}
              >
                <Flex
                  className={`${styles['inquiry-main-content-answer-box']}`}
                >
                  <TextArea
                    onChange={handleTextChange}
                    allowClear
                    type="text"
                    placeholder={
                      inquiryEndType
                        ? '답변을 수정하세요.'
                        : '답변을 입력하세요'
                    }
                    disabled={isLoading}
                    value={inquiryAnswer}
                    style={{
                      resize: 'none',
                      height: '11vh',
                    }}
                  />
                </Flex>
                <div
                  className={`${styles['inquiry-main-content-action-wrap']}`}
                >
                  <Flex
                    justify={'center'}
                    align={'center'}
                    onClick={() => {
                      if (inquiryAnswerValidation && !isLoading) {
                        submitInquiryAnswer()
                      }
                    }}
                    className={`${styles['inquiry-main-content-action']} ${inquiryAnswerValidation && !isLoading ? styles.active : ''}`}
                  >
                    전송
                  </Flex>
                </div>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
          onClick={closeModal}
        >
          <div
            style={{
              width: '90%',
              height: '90%',
              overflow: 'hidden',
            }}
          >
            <img
              src={modalImage}
              alt="modalImage"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default InquiryListPage
